import React from "react";
import Card from "../../components/Card";
import Table from "../../components/Table";
import EditClientModal from "./Components/EditClientModal";
import {
  documentStatusOptions,
  approveStatusOptions,
  entityCategoryOptions,
  lobTypeOptions,
  entityListColumns,
  useEntityList,
} from "./TableData";
import SearchBar from "../../components/SearchBar";
import dataNotFound from "../../assets/images/emptyPageImage.png";
import DropDown from "../../components/DropDown";
import { downloadEntityData } from "../../utils/downloadUtils";
import "./index.scss";

const ClientList = () => {
  const {
    isEditModalOpen,
    selectedClient,
    isLoading,
    handleEdit,
    handleSaveClient,
    handleApproveClient,
    handleDeficiencyClient,
    handleCloseModal,
    handleDelete,
    handleResendClient,
    currentEntities,
    pageSize,
    handleLoadMore,
    handleLoadLess,
    handleClearFilter,
    pagination,
    searchQuery,
    setSearchQuery,
    entityCategory,
    setEntityCategory,
    documentStatus,
    setDocumentStatus,
    approveStatus,
    setApproveStatus,
    lobType,
    setLobType,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    dateError,
  } = useEntityList();

  return (
    <div className="client-list-page">
      <div className="page-header">
        <h2 className="page-title">All Clients / Service Partner </h2>
      </div>

      {/* ── Filter bar: 2 rows ── */}
      <div className="filter-container-box">
        {/* Row 1: search (80%) + download button (20%) */}
        <div className="filter-row filter-row--top">
          <SearchBar
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder="Search by entity name, email..."
          />
          <button
            className="btn-download"
            title="Download data"
            onClick={() =>
              downloadEntityData({
                entityCategory: entityCategory || undefined,
                lobType: lobType || undefined,
                isVerified:
                  approveStatus === "true"
                    ? true
                    : approveStatus === "false"
                      ? false
                      : null,
                entityName:
                  searchQuery && !searchQuery.includes("@")
                    ? searchQuery
                    : undefined,
                emailAddress:
                  searchQuery && searchQuery.includes("@")
                    ? searchQuery
                    : undefined,
              })
            }
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download
          </button>
        </div>

        {/* Row 2: all dropdowns + date range */}
        <div className="filter-row filter-row--bottom">
          <DropDown
            name="entityCategory"
            value={entityCategory}
            onChange={(e) => setEntityCategory(e.target.value)}
            options={entityCategoryOptions}
          />
          <DropDown
            name="documentStatus"
            value={documentStatus}
            onChange={(e) => setDocumentStatus(e.target.value)}
            options={documentStatusOptions}
          />
          <DropDown
            name="approveStatus"
            value={approveStatus}
            onChange={(e) => setApproveStatus(e.target.value)}
            options={approveStatusOptions}
          />
          <DropDown
            name="lobType"
            value={lobType}
            onChange={(e) => setLobType(e.target.value)}
            options={lobTypeOptions}
          />
          <div className="date-range-filter">
            <input
              type="date"
              className={`date-input${dateError ? " date-input--error" : ""}`}
              value={dateFrom}
              max={dateTo || undefined}
              onChange={(e) => setDateFrom(e.target.value)}
              title="From date"
            />
            <span className="date-range-filter__sep">—</span>
            <input
              type="date"
              className={`date-input${dateError ? " date-input--error" : ""}`}
              value={dateTo}
              min={dateFrom || undefined}
              onChange={(e) => setDateTo(e.target.value)}
              title="To date"
            />
            {dateError && (
              <span className="date-range-filter__error">{dateError}</span>
            )}
          </div>
        </div>

        {/* Row 3: clear button — left aligned */}
        <div className="filter-row filter-row--actions">
          <button onClick={handleClearFilter} className="clear-filter-text">
            Clear filters
          </button>
        </div>
      </div>

      <Card>
        {isLoading ? (
          <div className="loading-state">
            <p>Loading entities...</p>
          </div>
        ) : currentEntities.length === 0 ? (
          <div className="empty-state">
            <img
              src={dataNotFound}
              className="data-not-found-img"
              alt="data not found"
            />
          </div>
        ) : (
          <div className="entity-table-wrapper">
            <Table
              columns={entityListColumns}
              data={currentEntities}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onResend={handleResendClient}
              showPagination={false}
            />
            <div className="simple-pagination">
              <button
                className="simple-pagination__btn"
                onClick={handleLoadLess}
                disabled={pageSize <= 10}
              >
                ‹ Less
              </button>
              <span className="simple-pagination__info">
                Showing {pageSize}
                {pagination.totalItems > 0 &&
                  ` · ${pagination.totalItems} total`}
              </span>
              <button
                className="simple-pagination__btn"
                onClick={handleLoadMore}
                disabled={currentEntities.length < pageSize}
              >
                More ›
              </button>
            </div>
          </div>
        )}
      </Card>

      <EditClientModal
        isOpen={isEditModalOpen}
        onClose={handleCloseModal}
        clientData={selectedClient}
        onSave={handleSaveClient}
        onApprove={handleApproveClient}
        onDeficiency={handleDeficiencyClient}
      />
    </div>
  );
};

export default ClientList;
